// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

(function(M, _, $, Backbone) {
  "use strict";

  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};

  /**
   * @class M.Community.View.ChallengeGrid
   *
   */
  M.Community.View.ChallengeGrid = Backbone.View.extend({
    template: M.Template.Community.ChallengeGrid,
    allStateVal: M.Config['ChallengeConfig'].
      state_query_string_types.all.query_param_val,

    _dropDownOptions: M.COMMUNITY.CHALLENGE.STATE_DROPDOWN_OPTIONS,
    numObjectsToShowOnLoad: 6,

    initialize: function() {
      this.$el = $(this.el);
      M.required(this.options.challenges);
    },

    render: function() {
      var that = this;
      this.$el.html(this.template(this.options));

      var challengeSection = this.$el.find('.challengeGrid');
      this.challengeList = new M.Community.Collection.ChallengeList(
        this.options.challenges);

      _.each(this.challengeList.models, function(challenge) {
        var challengeTile = new M.Community.View.ChallengeTile({
          model: challenge
        });
        $(challengeSection).append(challengeTile.render().el);
      });

      this._renderDropDown();

      return this;
    },

    _renderToggle: function() {
      var that = this;
      var initialStateToFilter = this._getInitialStateToFilter();
      var classToFilter = this._getClassToFilter(initialStateToFilter);

      var $parentEl = $('#challenges');
      this.showHidePanel = new M.Community.View.Util.ShowHide({
        numObjectsToShow: that.numObjectsToShowOnLoad,
        classToFilter: 'challengeTile' + classToFilter,
        pageClass: 'challengePage',
        itemsParentPanelEl: $parentEl
      });

      this.showHidePanel.$el.insertAfter($parentEl);
      return this;
    },

    _renderDropDown: function() {
      var that = this;

      var initialStateToFilter = this._getInitialStateToFilter();

      var dropdownListModel = new M.Model.DropdownPicker({
        sortOptionsList: this._dropDownOptions,
        selectedSortOption: initialStateToFilter
      });

      var dropdownPicker = new M.View.DropdownPicker({
        model: dropdownListModel,
        pickerLabel: "FILTER BY:"
      });

      var challengesHeader = this.$el.find('.challengesHeader');
      $(challengesHeader).append(dropdownPicker.el);
      $(".dropdownPickerTarget").html(dropdownPicker.render().el);

      var optionChangeHandler = function(dropdownListModel) {
        var state = dropdownListModel.get("selectedSortOption");
        that.filter(state);
        var filterUrl =
          M.html.htmlAttributeEscape(that.options.urlPaths.filterUrl) +
          '?state=' + encodeURIComponent(state);
        var classToFilter = that._getClassToFilter(state);

        window.history.pushState(state, "", filterUrl);
        that.showHidePanel.render('challengeTile' + classToFilter);
      }
      dropdownListModel.bind("change:selectedSortOption", optionChangeHandler);
    },

    _getInitialStateToFilter: function() {
      /**
       * If user navigates to page with initialStateFilter option set,
       * challenge tiles need to be filtered upon pageload
       * otherwise, the grid shows all challenge tiles by default
       */

      var initialState = this.options.initialStateFilter;
      if (!initialState) {
        initialState = this.allStateVal;
      }
      return initialState;
    },

    _getClassToFilter: function(state) {
      if (state === this.allStateVal) {
        return [''];
      }
      var classToFilter = [];
      _.each(M.Config['ChallengeConfig'].state_query_string_types, function(type) {
        if (state === type.query_param_val) {
          _.each(type.filter_class, function(filter_class) {
              classToFilter.push('.' + filter_class);
          });
        }
      });
      return classToFilter;
    },

    filter: function(stateStr) {
      var isFirst = true;
      if (stateStr === 'all' || !stateStr) {
        $('.noChallenges').hide();
        $('.challengeTile').show();
      } else {
        var classToFilter = this._getClassToFilter(stateStr);
        _.each(classToFilter, function(filter) {
          var selectedTilesClass = '.challengeTile' + filter;
          var challengeCount = $(selectedTilesClass).length;
          if (challengeCount > 0) {
            if (isFirst) {
              $('.challengeTile').hide();
            }
            $('.noChallenges').hide();
            $(selectedTilesClass).show();
          } else {
            if (isFirst) {
              $('.challengeTile').hide();
              $('.noChallenges').show();
            }
          }
          isFirst = false;
        });
      }
    }

  });
})(M, _, $, Backbone);
